import axios from 'axios';
export default (creds) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .postForm(`${process.env.VUE_APP_API_ADMIN_LOCATION}employees/import`, creds)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
